export default {
  categories: [
    {
      id: 1,
      name: "Satılık",
      subCategories: [
        {
          title: "Genel",
          children: [
            {
              name: "Satılık Daire",
              href: "/satilik-daire",
            },
            {
              name: "Satılık İş Yeri",
              href: "/satilik-isyeri",
            },
            {
              name: "Satılık Arsa",
              href: "/satilik-arsa",
            },
            {
              name: "Satılık Turistik Tesis",
              href: "/satilik-turistik-tesis",
            },
            {
              name: "Satılık Konut",
              href: "/satilik-konut",
            },
          ],
        },
        {
          title: "Daire",
          children: [
            {
              name: "İstanbul Satılık Daire",
              href: "/satilik-daire/istanbul",
            },
            {
              name: "Ankara Satılık Daire",
              href: "/satilik-daire/ankara",
            },
            {
              name: "İzmir Satılık Daire",
              href: "/satilik-daire/izmir",
            },
            {
              name: "Diyarbakır Satılık Daire",
              href: "/satilik-daire/diyarbakir",
            },
            {
              name: "Balıkesir Satılık Daire",
              href: "/satilik-daire/balikesir",
            },
          ],
        },
        {
          title: "İş Yeri",
          children: [
            {
              name: "İstanbul Satılık İş Yeri",
              href: "/satilik-isyeri/istanbul",
            },
            {
              name: "Ankara Satılık İş Yeri",
              href: "/satilik-isyeri/ankara",
            },
            {
              name: "İzmir Satılık İş Yeri",
              href: "/satilik-isyeri/izmir",
            },
            {
              name: "Diyarbakır Satılık İş Yeri",
              href: "/satilik-isyeri/diyarbakir",
            },
            {
              name: "Balıkesir Satılık İş Yeri",
              href: "/satilik-isyeri/balikesir",
            },
          ],
        },
        {
          title: "Arsa",
          children: [
            {
              name: "İstanbul Satılık Arsa",
              href: "/satilik-arsa/istanbul",
            },
            {
              name: "Ankara Satılık Arsa",
              href: "/satilik-arsa/ankara",
            },
            {
              name: "İzmir Satılık Arsa",
              href: "/satilik-arsa/izmir",
            },
            {
              name: "Diyarbakır Satılık Arsa",
              href: "/satilik-arsa/diyarbakir",
            },
            {
              name: "Balıkesir Satılık Arsa",
              href: "/satilik-arsa/balikesir",
            },
          ],
        },
        {
          title: "Konut Projeleri",
          children: [
            {
              name: "İstanbul Konut Projeleri",
              href: "/satilik-konut/istanbul/projeler",
            },
            {
              name: "Ankara Konut Projeleri",
              href: "/satilik-konut/ankara/projeler",
            },
            {
              name: "İzmir Konut Projeleri",
              href: "/satilik-konut/izmir/projeler",
            },
            {
              name: "Diyarbakır Konut Projeleri",
              href: "/satilik-konut/diyarbakir/projeler",
            },
            {
              name: "Balıkesir Konut Projeleri",
              href: "/satilik-konut/balikesir/projeler",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      name: "Kiralık",
      subCategories: [
        {
          title: "Genel",
          children: [
            {
              name: "Kiralık Daire",
              href: "/kiralik-daire",
            },
            {
              name: "Kiralık İş Yeri",
              href: "/kiralik-isyeri",
            },
            {
              name: "Kiralık Arsa",
              href: "/kiralik-arsa",
            },
            {
              name: "Kiralık Turistik Tesis",
              href: "/kiralik-turistik-tesis",
            },
            {
              name: "Kiralık Konut",
              href: "/kiralik-konut",
            },
          ],
        },
        {
          title: "Daire",
          children: [
            {
              name: "İstanbul Kiralık Daire",
              href: "/kiralik-daire/istanbul",
            },
            {
              name: "Ankara Kiralık Daire",
              href: "/kiralik-daire/ankara",
            },
            {
              name: "İzmir Kiralık Daire",
              href: "/kiralik-daire/izmir",
            },
            {
              name: "Diyarbakır Kiralık Daire",
              href: "/kiralik-daire/diyarbakir",
            },
            {
              name: "Balıkesir Kiralık Daire",
              href: "/kiralik-daire/balikesir",
            },
          ],
        },
        {
          title: "İş Yeri",
          children: [
            {
              name: "İstanbul Kiralık İş Yeri",
              href: "/kiralik-isyeri/istanbul",
            },
            {
              name: "Ankara Kiralık İş Yeri",
              href: "/kiralik-isyeri/ankara",
            },
            {
              name: "İzmir Kiralık İş Yeri",
              href: "/kiralik-isyeri/izmir",
            },
            {
              name: "Diyarbakır Kiralık İş Yeri",
              href: "/kiralik-isyeri/diyarbakir",
            },
            {
              name: "Balıkesir Kiralık İş Yeri",
              href: "/kiralik-isyeri/balikesir",
            },
          ],
        },
        {
          title: "Arsa",
          children: [
            {
              name: "İstanbul Kiralık Arsa",
              href: "/kiralik-arsa/istanbul",
            },
            {
              name: "Ankara Kiralık Arsa",
              href: "/kiralik-arsa/ankara",
            },
            {
              name: "İzmir Kiralık Arsa",
              href: "/kiralik-arsa/izmir",
            },
            {
              name: "Diyarbakır Kiralık Arsa",
              href: "/kiralik-arsa/diyarbakir",
            },
            {
              name: "Balıkesir Kiralık Arsa",
              href: "/kiralik-arsa/balikesir",
            },
          ],
        },
        {
          title: "Günlük Kiralık Daireler",
          children: [
            {
              name: "İstanbul Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/istanbul",
            },
            {
              name: "Ankara Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/ankara",
            },
            {
              name: "İzmir Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/izmir",
            },
            {
              name: "Balıkesir Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/balikesir",
            },
            {
              name: "Diyarbakır Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/diyarbakir",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      name: "Sahibinden",
      subCategories: [
        {
          title: "Genel",
          children: [
            {
              name: "Sahibinden Satılık Daire",
              href: "/satilik-daire/sahibinden",
            },
            {
              name: "Sahibinden Satılık İş Yeri",
              href: "/satilik-isyeri/sahibinden",
            },
            {
              name: "Sahibinden Satılık Arsa",
              href: "/satilik-arsa/sahibinden",
            },
            {
              name: "Sahibinden Satılık Turistik Tesis",
              href: "/satilik-turistik-tesis/sahibinden",
            },
            {
              name: "Sahibinden Satılık Konut",
              href: "/satilik-konut/sahibinden",
            },
          ],
        },
        {
          title: "Daire",
          children: [
            {
              name: "Sahibinden İstanbul Satılık Daire",
              href: "/satilik-daire/istanbul/sahibinden",
            },
            {
              name: "Sahibinden Ankara Satılık Daire",
              href: "/satilik-daire/ankara/sahibinden",
            },
            {
              name: "Sahibinden İzmir Satılık Daire",
              href: "/satilik-daire/izmir/sahibinden",
            },
            {
              name: "Sahibinden Diyarbakır Satılık Daire",
              href: "/satilik-daire/diyarbakir/sahibinden",
            },
            {
              name: "Sahibinden Balıkesir Satılık Daire",
              href: "/satilik-daire/balikesir/sahibinden",
            },
          ],
        },
        {
          title: "İş Yeri",
          children: [
            {
              name: "Sahibinden İstanbul Satılık İş Yeri",
              href: "/satilik-isyeri/istanbul/sahibinden",
            },
            {
              name: "Sahibinden Ankara Satılık İş Yeri",
              href: "/satilik-isyeri/ankara/sahibinden",
            },
            {
              name: "Sahibinden İzmir Satılık İş Yeri",
              href: "/satilik-isyeri/izmir/sahibinden",
            },
            {
              name: "Sahibinden Diyarbakır Satılık İş Yeri",
              href: "/satilik-isyeri/diyarbakir/sahibinden",
            },
            {
              name: "Sahibinden Balıkesir Satılık İş Yeri",
              href: "/satilik-isyeri/balikesir/sahibinden",
            },
          ],
        },
        {
          title: "Arsa",
          children: [
            {
              name: "Sahibinden İstanbul Satılık Arsa",
              href: "/satilik-arsa/istanbul/sahibinden",
            },
            {
              name: "Sahibinden Ankara Satılık Arsa",
              href: "/satilik-arsa/ankara/sahibinden",
            },
            {
              name: "Sahibinden İzmir Satılık Arsa",
              href: "/satilik-arsa/izmir/sahibinden",
            },
            {
              name: "Sahibinden Diyarbakır Satılık Arsa",
              href: "/satilik-arsa/diyarbakir/sahibinden",
            },
            {
              name: "Sahibinden Balıkesir Satılık Arsa",
              href: "/satilik-arsa/balikesir/sahibinden",
            },
          ],
        },
        {
          title: "Satılık Villalar",
          children: [
            {
              name: "Sahibinden Balıkesir Satılık Villa",
              href: "/satilik-villa/balikesir/sahibinden",
            },
            {
              name: "Sahibinden İstanbul Satılık Villa",
              href: "/satilik-villa/istanbul/sahibinden",
            },
            {
              name: "Sahibinden Diyarbakır Satılık Villa",
              href: "/satilik-villa/diyarbakir/sahibinden",
            },
            {
              name: "Sahibinden İzmir Satılık Villa",
              href: "/satilik-villa/izmir/sahibinden",
            },
            {
              name: "Sahibinden Ankara Satılık Villa",
              href: "/satilik-villa/ankara/sahibinden",
            },
          ],
        },
      ],
    },
    {
      id: 4,
      name: "Popüler",
      subCategories: [
        {
          title: null,
          children: [
            {
              name: "Antalya Kiralık Daire",
              href: "/kiralik-daire/antalya",
            },
            {
              name: "Eskişehir Kiralık Daire",
              href: "/kiralik-daire/eskisehir",
            },
            {
              name: "Diyarbakır Kiralık Daire",
              href: "/kiralik-daire/diyarbakir",
            },
            {
              name: "Balıkesir Kiralık Daire",
              href: "/kiralik-daire/balikesir",
            },
            {
              name: "Malatya Kiralık Daire",
              href: "/kiralik-daire/malatya",
            },
            {
              name: "Konya Kiralık Daire",
              href: "/kiralik-daire/konya",
            },
          ],
        },
        {
          title: null,
          children: [
            {
              name: "Kiralık Villa",
              href: "/kiralik-villa",
            },
            {
              name: "Antalya Kiralık Villa",
              href: "/kiralik-villa/antalya",
            },
            {
              name: "Bodrum Kiralık Villa",
              href: "/kiralik-villa/mugla-bodrum",
            },
            {
              name: "Fethiye Kiralık Villa",
              href: "/kiralik-villa/mugla-fethiye",
            },
            {
              name: "Kaş Kiralık Villa",
              href: "/kiralik-villa/antalya-kas",
            },
            {
              name: "Mersin Kiralık Villa",
              href: "/kiralik-villa/mersin",
            },
          ],
        },
        {
          title: null,
          children: [
            {
              name: "Satılık Villa",
              href: "/satilik-villa",
            },
            {
              name: "Kuşadası Satılık Villa",
              href: "/satilik-villa/aydin-kusadasi",
            },
            {
              name: "İzmir Satılık Villa",
              href: "/satilik-villa/izmir",
            },
            {
              name: "Bodrum Satılık Villa",
              href: "/satilik-villa/mugla-bodrum",
            },
            {
              name: "Ankara Satılık Villa",
              href: "/satilik-villa/ankara",
            },
            {
              name: "Urla Satılık Villa",
              href: "/satilik-villa/izmir-urla",
            },
          ],
        },
        {
          title: null,
          children: [
            {
              name: "Gaziantep Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/gaziantep",
            },
            {
              name: "Bursa Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/bursa",
            },
            {
              name: "Samsun Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/samsun",
            },
            {
              name: "Adana Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/adana",
            },
            {
              name: "Eskişehir Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/eskisehir",
            },
            {
              name: "Balıkesir Günlük Kiralık Daire",
              href: "/gunluk-kiralik-daire/balikesir",
            },
          ],
        },
        {
          title: null,
          children: [
            {
              name: "Tekirdağ Satılık Arsa",
              href: "/satilik-arsa/tekirdag",
            },
            {
              name: "Balıkesir Satılık Arsa",
              href: "/satilik-arsa/balikesir",
            },
            {
              name: "Çanakkale Satılık Arsa",
              href: "/satilik-arsa/canakkale",
            },
            {
              name: "Kırklareli Satılık Arsa",
              href: "/satilik-arsa/kirklareli",
            },
            {
              name: "Sakarya Satılık Arsa",
              href: "/satilik-arsa/sakarya",
            },
            {
              name: "Kütahya Satılık Arsa",
              href: "/satilik-arsa/kutahya",
            },
          ],
        },
      ],
    },
  ],
  footerListData: [
    {
      title: "Emlakjet",
      children: [
        {
          name: "Hakkımızda",
          href: "/hakkimizda",
        },
        {
          name: "Ödüllerimiz",
          href: "/odullerimiz",
        },
        {
          name: "Kurumsal Materyaller",
          href: "/kurumsal-materyaller",
        },
        {
          name: "Reklam",
          href: "/reklam",
        },
        {
          name: "İnsan Kaynakları",
          href: "/insan-kaynaklari",
        },
        {
          name: "Site Haritası",
          href: "/site-haritasi",
        },
      ],
    },
    {
      title: "Hizmetlerimiz",
      children: [
        {
          name: "Size Özel Hizmetlerimiz",
          href: "/hizmetler/hizmetlerimiz",
        },
        {
          name: "Emlak Haberleri",
          href: "/haber",
        },
        {
          name: "Kurumsal Üyelik",
          href: "/uye-ol/kurumsal",
        },
        {
          name: "Projeler",
          href: "/satilik-konut/projeler",
        },
        {
          name: "Ücretsiz ilan Ver",
          href: "/uye-ol/bireysel",
          loginUrl: `#/member/authorize`,
        },
        // {
        //   name: "Jettaşın",
        //   href: "/jettasin/",
        // },
        // {
        //   name: "Konut Kredisi Hesaplama",
        //   href: "/hizmetlerimiz/akbank-konut-kredisi/",
        // },
      ],
    },
    {
      title: "Diğer",
      children: [
        {
          name: "İlan Yayınlama Kuralları",
          slug: "ilan-yayinlama-kurallari",
        },
        {
          name: "Kullanım Koşulları",
          slug: "kullanim-kosullari",
        },
        {
          name: "İşlem Rehberi",
          slug: "islem-rehberi",
        },
        {
          name: "Üyelik Sözleşmesi ve Gizlilik Politikası",
          slug: "uyelik-sozlesmesi",
        },
        {
          name: "Çerez Politikası",
          slug: "cerez-politikasi",
        },
        {
          name: "Çerez Ayarları",
          slug: "cerez-yonetimi",
        },
      ],
    },
    {
      title: "",
      children: [
        {
          name: "Açık Rıza Metni",
          slug: "acik-riza-metni",
        },
        {
          name: "Kullanıcı Aydınlatma Metni",
          slug: "kvkk-hakkinda",
        },
        {
          name: "Çalışan Adayı Aydınlatma Metni",
          slug: "calisan-adayi-aydinlatma-metni",
        },
      ],
    },
  ],
  brands: [
    { title: "Kariyer.net", href: "https://www.kariyer.net/" },
    { title: "İşin Olsun", href: "https://isinolsun.com/" },
    { title: "Sigortam.net", href: "https://www.sigortam.net/" },
    { title: "Arabam.com", href: "https://www.arabam.com/" },
    { title: "Hangikredi", href: "https://www.hangikredi.com/" },
    { title: "Cimri", href: "https://www.cimri.com/" },
    { title: "Neredekal", href: "https://www.neredekal.com/" },
    { title: "SteelOrbis", href: "https://tr.steelorbis.com/" },
    { title: "Chemorbis", href: "https://www.chemorbis.com/tr/" },
    { title: "Endeksa", href: "https://www.endeksa.com/tr/" },
  ],
};

export const bottomPaddingRoutes = ["/kibris-yatirim-firsatlari"];
